import Loading from 'components/Loading';
import settingServiceSelectors from 'features/settingService/services/selectors';
import { LoadingPageStyled } from 'services/UI/LoadingPage';
import shopSelectors from 'services/shop/selectors';
import styled from 'styled-components';
import CategoryPart from './CategoryPart';
import useGetPackageProgramList from 'features/settingService/services/hooks/useGetPackageProgramList';
import settingServiceActions from 'features/settingService/services/actions';
import { useAppDispatch } from 'store/hooks';
import PackageDetail from './PackageDetail';
import { getMessageError, IResponseDataBody } from 'services/response';
import toast from 'utils/toast';
import settingApis from 'features/settingService/services/apis';
import { useEffect, useMemo } from 'react';

const PackageSetting = () => {
  const [data, mutate] = useGetPackageProgramList();
  const dispatch = useAppDispatch();
  const activePackageId = settingServiceSelectors.getActivePackageProgramId();
  console.log('activePackage:', activePackageId);
  const loading = shopSelectors.loading.categories();

  const activePackage = useMemo(() => {
    return data?.find((item) => item.id === activePackageId) || null;
  }, [data, activePackageId]);

  if (loading && data && data?.length <= 1)
    return (
      <Container className='v2'>
        <Loading />
      </Container>
    );

  const setActivePackageProgram = (id: string) => {
    dispatch(settingServiceActions.setActivePackageProgram(id));
  };

  const handleDeletePackage = async (id: string) => {
    try {
      const res : IResponseDataBody = await settingApis.deletePackageProgram(id);
      if (res?.data?.data) {
        toast.success('Delete package successfully');
        mutate();
      }
    } catch (error) {
      toast.error(getMessageError(error) || 'Delete package failed');
    }
  };

  const handleEditNameCate = async (cateId: string, value: string) => {
    if (!activePackage) return;

    try {
      const res : IResponseDataBody = await settingApis.updatePackageProgram({
        id: cateId,
        body: {
          ...activePackage,
          name: value,
        },
      });
      if (res?.data?.data) {
        toast.success('Update package name successfully');
        mutate();
      }
    } catch (error) {
      toast.error(getMessageError(error) || 'Update package name failed');
    }
  };

  useEffect(() => {
    if (data && data.length > 0 && !activePackage) {
      setActivePackageProgram(data[0].id);
    }
  }, [data, activePackage]);
  
  return (
    <>
      <Container>
        <CategoryPart
          onEditNameCate={handleEditNameCate}
          data={data || []}
          activeCate={activePackage}
          onChoosePackage={setActivePackageProgram}
          onDeletePackage={handleDeletePackage}
        />
        <PackageDetail
          data={activePackage}
          onDeletePackage={handleDeletePackage}
        />
      </Container>
      {loading && (
        <LoadingPageStyled>
          <div className='box'>
            <Loading />
          </div>
        </LoadingPageStyled>
      )}
    </>
  );
};

export default PackageSetting;

const Container = styled.div`
  display: flex;
  justify-content: center;
  gap: 24px;
  padding-top: 16px;
  background-color: #F1F5F9;
  height: calc(100% - 8px);
`;
